'use strict';

const constants = {
  APPLIED: 'applied',
  ERROR: 'error',
  NO_EVENT: 'NO_EVENT',
  QUALIFIED: 'QUALIFIED',
};

module.exports = constants;
